const compareTracking = (item1, item2) => {
  const TRACKING_WEIGHT = 3;
  const HANDTRACKING_WEIGHT = 2;
  const EYETRACKING_WEIGHT = 1;
  const FACIALRECOGNITION_WEIGHT = 1;

  const itemWeight = (item, compareResult) => {
    let weight = 0;
    if (item.tracking === compareResult.tracking) {
      weight += TRACKING_WEIGHT;
    }
    if (item.handtracking === compareResult.handtracking) {
      weight += HANDTRACKING_WEIGHT;
    }
    if (item.eyetracking === compareResult.eyetracking) {
      weight += EYETRACKING_WEIGHT;
    }
    if (item.facialrecognition === compareResult.facialrecognition) {
      weight += FACIALRECOGNITION_WEIGHT;
    }
    return weight;
  };

  const compareResult = {
    tracking: 'Outside-in',
    handtracking: true,
    eyetracking: true,
    facialrecognition: true,
  };

  const itemWeight1 = itemWeight(item1, compareResult);
  const itemWeight2 = itemWeight(item2, compareResult);

  if (itemWeight1 === itemWeight2) {
    return [item1, item2];
  }
  return itemWeight1 > itemWeight2 ? [item1] : [item2];
};

module.exports = compareTracking;
